import { fas } from "@fortawesome/free-solid-svg-icons";
import React from "react";

export const stringReducer = (string, reqlenth) => {
  let splitedStr = string.split(" ");
  if (splitedStr.length > reqlenth) {
    return splitedStr.slice(0, reqlenth).join(" ") + "...";
  } else {
    return string;
  }
};

export const Image = ({
  src,
  className,
  alt = "Image not found",
  style,
  onLoad,
  aspectRatio = false,
}) => {
  const preUrl =
    !process.env.NODE_ENV || process.env.NODE_ENV === "development"
      ? "http://localhost:1337"
      : "";
  return aspectRatio ? (
    <div className={`relative pb-3/4 w-full`}>
      <img
        onLoad={onLoad}
        style={style}
        className={className + "  absolute object-cover w-full h-full"}
        src={src}
        alt={alt}
      ></img>
    </div>
  ) : (
    <img
      onLoad={onLoad}
      style={style}
      className={className + " object-cover "}
      src={src}
      alt={alt}
    ></img>
  );
};
